import React, { useEffect, useState } from 'react'
import { FormInput } from '../components/FormInput'
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom';

const RegInviteSubAcctStep3 = ({
    register,
    errors,
    inputCheckKeyDown,
    setValidForm,
    inviteObj

}) => {
    const { t } = useTranslation();
    const { issuer } = useParams();



  return (
    <>
       <div className="col-12 font-semibold">
        {t('organData')}
       </div>
        <div className='col-12'>
            <label
                className="form-label">
                {t("company_num")}
            </label>
            <span>{inviteObj?.taxIdNum}</span>
        </div>
        <div className='col-12'>
             <label
                className="form-label">
                {t("organName")}
            </label>
            <span>{inviteObj?.companyName}</span>
        </div>
    

        <div className="col-12 font-semibold">
            {t('accountProfile')}
        </div>
        <div className='col-12'>
            <FormInput
                labelClass="required"
                withLabel={true}
                register={register}
                errors={errors}
                id="userName"
                labelText={t('user_name')}
                type="text"
                rules={setValidForm('userName')}
                enterClick={inputCheckKeyDown}     
            />
        </div>
        {/* <div className='col-12'>
            <FormInput
                labelClass="required"
                withLabel={true}
                register={register}
                errors={errors}
                id="userPhone"
                labelText={t("tel")}
                type="text"
                rules={setValidForm('userPhone')}
                enterClick={inputCheckKeyDown}     
            />
        </div> */}
        <div className='col-12'>
            <FormInput
                disabled={issuer==='GOOGLE'}
                labelClass="required"
                withLabel={true}
                register={register}
                errors={errors}
                id="userEmail"
                labelText={t('user_email')}
                type="email"
                rules={setValidForm('userEmail')}
                enterClick={inputCheckKeyDown}     
            />
        </div>

    </>
  )
}

export default RegInviteSubAcctStep3